import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { catchError, map, take, Observable, of } from 'rxjs';
import { AuthService } from '../_services/auth.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { } 

  // canActivate(routeSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
  //   let customRedirect = routeSnapshot.data['authGuardRedirect'];
  //   let isUserLoggedIn = this.authService.isLogged;
  //   console.log("authService -> ", this.authService.isLogged)
  //   console.log("isUserLoggedIn -> ", isUserLoggedIn)


  //   if (!isUserLoggedIn) {
  //     let redirect = !!customRedirect ? customRedirect : '/connexion';
  //     console.log("redirect")
  //     this.router.navigate([redirect]);
      
  //   }
    

  //   return isUserLoggedIn;
  // }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    if (this.authService.isAuthenticated()) {
      console.log('were in');
      return true;
    }
    else {
      this.router.navigate(['connexion']);
      console.log('kicked out');
      return false;
    }
  }
}
